import { IonPage } from "@ionic/react";
import { IonCol, IonContent, IonGrid, IonRow } from "@ionic/react";
import "./CustomPageNotFound.css";

const CustomPageNotFound = () => {
  return (
    <IonPage>
      <IonContent>
        <IonGrid id="loginGrid">
          <IonRow id="loginRow">
            <IonCol id="loginMainContainer" size="12" size-md="6" offset-md="3">
              <div id="pageNotFoundContainer">
                <p>Page Not Found</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default CustomPageNotFound;
